import { Route, Routes } from 'react-router-dom'

import { Shell } from './components/Shell'
import { Loading, Notice, Page } from './components/ui'
import { useAuth } from './lib/auth'
import { AgentFlows } from './screens/AgentFlows'
import { AiModels } from './screens/AiModels'
import { AiRouting } from './screens/AiRouting'
import { AiUsage } from './screens/AiUsage'
import { Audit } from './screens/Audit'
import { Billing } from './screens/Billing'
import { CoachDetail } from './screens/CoachDetail'
import { Coaches } from './screens/Coaches'
import { CareLinks } from './screens/CareLinks'
import { Config } from './screens/Config'
import { Devices } from './screens/Devices'
import { Emergency } from './screens/Emergency'
import { Login } from './screens/Login'
import { Overview } from './screens/Overview'
import { PaymentGateways } from './screens/PaymentGateways'
import { Payouts } from './screens/Payouts'
import { PrivacyPolicy } from './screens/PrivacyPolicy'
import { PrivacyRequests } from './screens/PrivacyRequests'
import { Retention } from './screens/Retention'
import { Roles } from './screens/Roles'
import { SignIn } from './screens/SignIn'
import { System } from './screens/System'
import { UserDetail } from './screens/UserDetail'
import { Users } from './screens/Users'

function LockedOut() {
  const { user, signOut } = useAuth()
  return (
    <div className="login">
      <div className="login__card stack">
        <h1 style={{ fontSize: 20 }}>No console access</h1>
        <p className="muted" style={{ margin: 0 }}>
          <strong>{user?.email}</strong> signed in successfully but holds none of the
          permissions this console requires. Roles on the account: {user?.roles.join(', ') || 'none'}.
        </p>
        <Notice>
          This is the expected result for a patient account. Console access needs a role
          carrying <span className="mono">admin:read</span> — granted by a superadmin, and
          recorded in the audit log.
        </Notice>
        <button className="btn" onClick={() => void signOut()}>
          Sign out
        </button>
      </div>
    </div>
  )
}

function NotFound() {
  return (
    <Page title="Not found" subtitle="That screen does not exist in this console.">
      <div />
    </Page>
  )
}

export function App() {
  const { ready, user, lockedOut } = useAuth()

  if (!ready) {
    return (
      <div className="login">
        <div className="login__card">
          <Loading rows={3} />
        </div>
      </div>
    )
  }
  if (!user) return <Login />
  if (lockedOut) return <LockedOut />

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route index element={<Overview />} />
        <Route path="users" element={<Users />} />
        <Route path="users/:userId" element={<UserDetail />} />
        <Route path="roles" element={<Roles />} />
        <Route path="care-links" element={<CareLinks />} />
        <Route path="emergency" element={<Emergency />} />
        <Route path="devices" element={<Devices />} />
        <Route path="ai/usage" element={<AiUsage />} />
        <Route path="ai/models" element={<AiModels />} />
        <Route path="ai/routing" element={<AiRouting />} />
        <Route path="ai/agents" element={<AgentFlows />} />
        <Route path="privacy/policy" element={<PrivacyPolicy />} />
        <Route path="privacy/requests" element={<PrivacyRequests />} />
        <Route path="audit" element={<Audit />} />
        <Route path="coaches" element={<Coaches />} />
        <Route path="coaches/:coachId" element={<CoachDetail />} />
        <Route path="payouts" element={<Payouts />} />
        <Route path="payments/gateways" element={<PaymentGateways />} />
        <Route path="billing" element={<Billing />} />
        <Route path="sign-in" element={<SignIn />} />
        <Route path="config" element={<Config />} />
        <Route path="retention" element={<Retention />} />
        <Route path="system" element={<System />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  )
}
